module.exports = __webpack_public_path__ + "img/数字人.2eaabaeb.png";